export const RequestUnserviceableHistoryHeaders = [
  {
    header: "PN",
    key: "PN",
    width: 25,
  },
  {
    header: "SN",
    key: "SN",
  },
  {
    header: "ESTIMATED DELIVERY DATE",
    key: "ESTIMATED DELIVERY DATE",
  },
  {
    header: "TSO",
    key: "TSO",
  },
  {
    header: "CSO",
    key: "CSO",
  },
  {
    header: "TSR",
    key: "TSR",
  },
  {
    header: "CSR",
    key: "CSR",
  },
  {
    header: "TSN",
    key: "TSN",
  },
  {
    header: "CSN",
    key: "CSN",
  },
  {
    header: "DSN",
    key: "DSN",
  },
  {
    header: "TSI",
    key: "TSI",
  },
  {
    header: "CSI",
    key: "CSI",
  },
  {
    header: "DSI",
    key: "DSI",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "UPDATED BY",
    key: "UPDATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
  {
    header: "UPDATED DATE",
    key: "UPDATED DATE",
  },
  {
    header: "REMOVE DATE FROM AC",
    key: "REMOVE DATE FROM AC",
  },
  {
    header: "STATUS",
    key: "STATUS",
  },
  {
    header: "SUBMITTED DATE",
    key: "SUBMITTED DATE",
  },
  {
    header: "CARRIER",
    key: "CARRIER",
  },
  {
    header: "DSO",
    key: "DSO",
  },
  {
    header: "REMOVE REASON REMARK",
    key: "REMOVE REASON REMARK",
  },
  {
    header: "REMOVE REASON SUB CATEGORY",
    key: "REMOVE REASON SUB CATEGORY",
  },
  {
    header: "REMOVE REASON TYPE",
    key: "REMOVE REASON TYPE",
  },
  {
    header: "FLIGHT DATE",
    key: "FLIGHT DATE",
  },
  {
    header: "AIRPORT CODE",
    key: "AIRPORT CODE",
  },
  {
    header: "REMOVE FROM AC",
    key: "REMOVE FROM AC",
  },
  {
    header: "ORDINO DATE",
    key: "ORDINO DATE",
  },
];

export const RequestUnserviceableHistoryExcelName = "Core Unit History";

export const RequestServiceableHistoryHeaders = [
  {
    header: "CREATED BY",
    key: "CREATED BY",
    width: 25,
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
  {
    header: "UPDATED BY",
    key: "UPDATED BY",
  },
  {
    header: "UPDATED DATE",
    key: "UPDATED DATE",
  },
  {
    header: "PN",
    key: "PN",
  },
  {
    header: "SN",
    key: "SN",
  },
  {
    header: "AWB",
    key: "AWB",
  },
  {
    header: "FLIGHT NO",
    key: "FLIGHT NO",
  },
  {
    header: "REQUESTED DELIVERY DATE",
    key: "REQUESTED DELIVERY DATE",
  },
  {
    header: "ESTIMATED DELIVERY DATE",
    key: "ESTIMATED DELIVERY DATE",
  },
  {
    header: "SUBMITTED BY",
    key: "SUBMITTED BY",
  },
  {
    header: "SUBMITTED DATE",
    key: "SUBMITTED DATE",
  },
  {
    header: "CARRIER",
    key: "CARRIER",
  },
  {
    header: "FLIGHT DATE",
    key: "FLIGHT DATE",
  },
];

export const RequestServiceableHistoryExcelName = "Serviceable History";

export const RequestOrderHistoryHeaders = [
  {
    header: "REF NO",
    key: "REF NO",
    width: 25,
  },
  {
    header: "IS DEFINED",
    key: "IS DEFINED",
  },
  {
    header: "REQUESTED DELIVERY DATE",
    key: "REQUESTED DELIVERY DATE",
  },
  {
    header: "CHAPTER",
    key: "CHAPTER",
  },
  {
    header: "RELEASE TYPE",
    key: "RELEASE TYPE",
  },
  {
    header: "AIRPORT CODE",
    key: "AIRPORT CODE",
  },
  {
    header: "CUSTOMER PO",
    key: "CUSTOMER PO",
  },
  {
    header: "CUSTOMER PO LINE",
    key: "CUSTOMER PO LINE",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "UPDATED BY",
    key: "UPDATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
  {
    header: "UPDATED DATE",
    key: "UPDATED DATE",
  },
  {
    header: "PN",
    key: "PN",
  },
  {
    header: "COMPONENT DESCRIPTION",
    key: "COMPONENT DESCRIPTION",
  },
  {
    header: "ACCESS",
    key: "ACCESS",
  },
  {
    header: "REPAIR",
    key: "REPAIR",
  },
  {
    header: "IS POOL",
    key: "IS POOL",
  },
  {
    header: "REPAIR TAT",
    key: "REPAIR TAT",
  },
  {
    header: "RECEIVED DATE",
    key: "RECEIVED DATE",
  },
  {
    header: "TRANSACTION TYPE",
    key: "TRANSACTION TYPE",
  },
  {
    header: "WORKSHOP",
    key: "WORKSHOP",
  },
];

export const RequestOrderHistoryExcelName = "Request Order History";
